import type { ReactNode } from "react";

const TONES = {
  aqua: { pill: "bg-app-aqua/10 text-app-ink", dot: "bg-app-aqua" },
  mint: { pill: "bg-app-mint/15 text-green-800", dot: "bg-app-mint" },
  overdue: { pill: "bg-app-overdue/10 text-app-overdue", dot: "bg-app-overdue" },
  muted: { pill: "bg-gray-100 text-gray-600", dot: "bg-gray-400" },
} as const;

interface StatPillProps {
  children: ReactNode;
  tone?: keyof typeof TONES;
}

/** The student app's count badge: a dot and a short label. */
export function StatPill({ children, tone = "aqua" }: StatPillProps) {
  const { pill, dot } = TONES[tone];

  return (
    <span
      className={`inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-sm font-extrabold ${pill}`}
    >
      <span className={`h-2.5 w-2.5 shrink-0 rounded-full ${dot}`} />
      {children}
    </span>
  );
}
